import './definitionList.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DefinitionList = forwardRef((props, ref) => {
  const className = classNames({
    'def-list': true,
    [props.className]: props.className,
  });

  return (
    <dl ref={ref} className={className}>
      {props.children}
    </dl>
  );
});

DefinitionList.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Term = forwardRef((props, ref) => {
  const className = classNames({
    'def-term': true,
    [props.className]: props.className,
  });

  return (
    <dt ref={ref} className={className}>
      {props.children}
    </dt>
  );
});

Term.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Description = forwardRef((props, ref) => {
  const className = classNames({
    'def-desc': true,
    [props.className]: props.className,
  });

  return (
    <dd ref={ref} className={className}>
      {props.children}
    </dd>
  );
});

Description.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

DefinitionList.Term = Term;
DefinitionList.Description = Description;

export default DefinitionList;
